/**
 * Выгрузка CSV в UTF-8 с BOM (ТЗ §4.5 «отчёты выгружаются в XLSX и CSV
 * в UTF-8 с BOM»). Разделитель — «;», как ожидает русский Excel.
 */
export type CsvCell = string | number | boolean | null | undefined;

export const CSV_BOM = '\uFEFF';
export const CSV_SEPARATOR = ';';

function escapeCell(value: CsvCell): string {
  if (value === null || value === undefined) return '';
  const text = String(value);
  if (
    text.includes(CSV_SEPARATOR) ||
    text.includes('"') ||
    text.includes('\n') ||
    text.includes('\r')
  ) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/** Собирает CSV-текст с BOM. Первая строка — заголовок. */
export function buildCsv(rows: CsvCell[][]): string {
  const body = rows.map((row) => row.map(escapeCell).join(CSV_SEPARATOR)).join('\r\n');
  return `${CSV_BOM}${body}\r\n`;
}

export function downloadFile(filename: string, content: BlobPart, mime: string): void {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Освобождаем URL после запуска скачивания.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadCsv(filename: string, rows: CsvCell[][]): void {
  downloadFile(filename, buildCsv(rows), 'text/csv;charset=utf-8');
}
